import React from "react";
import Select from "react-select";
import {Controller} from "react-hook-form";
import ValidationMsgComponent from "../ValidationMsgComponent";
import {Label, } from "reactstrap";

interface ControlledSelectProps {
    inputName: string;
    placeholder?: string;
    invalid?: boolean;
    control: any;
    rules?: object;
    errors?: object;
    isRequired?: boolean;
    hasSideLabel?: boolean;
    sideLabel?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    className?: string;
    optionsList: any;
    isLoading?: boolean;
    isSearchable?: boolean;
    defaultSelectedValue?: any;
    isMulti?: boolean;
    isClear?: boolean;
    value?: any;
    onChange?: (option: any) => void;
}

const ControlledRowSelectPortion: React.FC<ControlledSelectProps> = ({
                                                                         inputName,
                                                                         optionsList,
                                                                         invalid,
                                                                         control,
                                                                         isLoading,
                                                                         isSearchable,
                                                                         rules,
                                                                         errors,
                                                                         defaultSelectedValue,
                                                                         isRequired,
                                                                         isMulti,
                                                                         isDisabled,
                                                                         placeholder,
                                                                         isClear,
                                                                         onChange
                                                                     }) => {
    return (
        <div className="">
            <Label>Portion Size</Label>
            <Controller
                name={inputName}
                control={control}
                rules={rules}
                render={({field}) => (
                    <Select
                        id={inputName}
                        classNamePrefix="select"
                        options={optionsList}
                        isClearable={isClear}
                        isLoading={isLoading}
                        isSearchable={isSearchable}
                        isMulti={isMulti}
                        isDisabled={isDisabled}
                        defaultValue={defaultSelectedValue}
                        placeholder={placeholder}
                        {...field}
                        required={isRequired}
                        onChange={(option) => {
                            field.onChange(option);
                            if (onChange) onChange(option);
                        }}
                    />
                )}
            />
            {invalid && (
                <ValidationMsgComponent
                    inputName={inputName}
                    invalid={invalid}
                    errors={errors}
                    rules={rules}
                />
            )}

        </div>
    );
};
export default ControlledRowSelectPortion;